import { CommonSuccessAlertConfirmation } from 'gemlux-common-components';
import { Grid } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import * as _ from 'lodash';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import InputValidator from '../../../components/Subordinates/InputValidator/InputValidator';
import { RootState } from '../../../redux/store';
import { subordinateActions } from '../../../redux/subordinate/subordinateSlice';
import CustomLoader from '../../../components/CustomLoader/CustomLoader';
import SignUpForm from '../../../components/Subordinates/SignUpForm/SignUpForm';
import Logo from '../../../assets/img/logo-large.svg';

export interface NCCSubordinateSignUpFormProps {
  userName: string;
  firstName: string;
  lastName: string;
  nationality: string;
  password: string;
  confirmPassword: string;
  mobile: string;
  isAgreedToTermsAndCondition: boolean;
  companyName?: string;
  country?: string;
  role?: string;
  website?: string;
}

const NCCSubordinateSignUp = () => {
  const [searchParams] = useSearchParams();
  const inviteToken = searchParams.get('token');
  const { componentStatus } = useAppSelector((state: RootState) => state.subordinate);
  const createSubordinateLoading = Boolean(_.get(componentStatus, 'createSubordinateLoading', false));
  const activeStep = _.get(componentStatus, 'activeStep', '1');
  const creationError = _.get(componentStatus, 'creationError', undefined);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleSignUpSubmit = (data: NCCSubordinateSignUpFormProps) => {
    const { confirmPassword: ConfirmPassword, companyName, country, role, website, ...rest } = data;

    const companyDetails =
      companyName || country || role || website
        ? {
            companyName,
            country,
            role,
            website,
          }
        : undefined;

    const createSubordinateData = {
      ...rest,
      token: inviteToken || '',
      ...(companyDetails && { companyDetails }),
    };

    dispatch(subordinateActions.setComponentStatus({ creationError: undefined }));
    dispatch(subordinateActions.createSubordinateAsync(createSubordinateData));
  };

  const handleSignIn = () => {
    navigate('/login');
  };

  if (createSubordinateLoading) {
    return <CustomLoader />;
  }

  if (!createSubordinateLoading && activeStep === '1')
    return <SignUpForm error={creationError?.toString()} handleSubmit={handleSignUpSubmit} isNccUser />;

  if (!createSubordinateLoading && activeStep === '2')
    return (
      <Grid>
        <Grid position="absolute" top="20px" left="0" width="100%" display="flex" justifyContent="center">
          <Grid component="img" src={Logo} />
        </Grid>
        <CommonSuccessAlertConfirmation
          confirmText="Sign In Now"
          handleClick={handleSignIn}
          title="Account Created"
          description="Your account is created. Use your created login details to access your account and enjoy all the
amazing features."
        />
      </Grid>
    );
};

export default NCCSubordinateSignUp;
